:host {
  display: inline-flex;
  vertical-align: top;
}

.spw-radio {
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  gap: var(--spw-spacings-spacing-sm);

  &__wrapper {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    background-color: var(--spw-ds-white);
    border: 2px solid var(--spw-color-themes-grey-grey-900);
    border-radius: var(--spw-spacings-border-radius-full);
    font-size: var(--spw-typography-font-size-xs);
    flex: none;
    order: 0;
    flex-grow: 0;

    &--error {
      border-color: var(--spw-colors-dark-states-error-error-300);
    }

    &:not(.spw-radio__wrapper--disabled):hover {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }

    &:not(.spw-radio__wrapper--disabled):focus-visible,
    &:not(.spw-radio__wrapper--disabled):active,
    &:not(.spw-radio__wrapper--disabled):focus-within {
      outline: 2px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }

    &:not(.spw-radio__wrapper--disabled):active {
      box-shadow: 0 0 4px var(--spw-color-themes-grey-grey-300);
    }

    &--disabled {
      border-color: var(--spw-color-themes-grey-grey-500);
    }

    &--checked {
      border-color: var(--spw-ds-primary);
      color: var(--spw-ds-primary);

      &--disabled {
        color: var(--spw-color-themes-grey-grey-500);
      }
    }
  }

  &__circle {
    width: 10px;
    height: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: var(--spw-spacings-border-radius-full);
    background: var(--spw-ds-primary);
    display: block;
  }

  &__label {
    color: var(--spw-color-themes-grey-grey-900);
    word-wrap: break-word;
    order: 1;
    padding-top: 1px;
    user-select: none;

    &:hover ~ .spw-radio__wrapper:not(.spw-radio__wrapper--disabled) {
      outline: 4px solid var(--spw-color-themes-grey-grey-300);
    }

    &:active ~ .spw-radio__wrapper:not(.spw-radio__wrapper--disabled) {
      box-shadow: 0 0 4px var(--spw-color-themes-grey-grey-300);
      outline: 2px solid var(--spw-ds-focus);
      outline-offset: 2px;
    }

    &--disabled {
      color: var(--spw-color-themes-grey-grey-500);
    }
  }

  &__wrapper,
  &__label {
    &:hover {
      cursor: pointer;
    }
    &--disabled:hover {
      cursor: not-allowed;
    }
  }
}
